import Joi from 'joi';

/**
 * Schema for leased outbox record validation.
 */
export const leaseOutboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
